import { useHealthCenterRules } from "../../../../../utils/hooks";

const useIsAsyncPatientSearch = () =>
  useHealthCenterRules("patients")?.search?.strategy === "async";

export default useIsAsyncPatientSearch;
